// extracted by mini-css-extract-plugin
export default {"badges":"AssessorMetrics_badges__YDSms","badgeDanger":"AssessorMetrics_badgeDanger__2AmlM","badgeNeutral":"AssessorMetrics_badgeNeutral__cW8Jz"};